import { useEffect } from 'react';

import { auth, authTools, db, fsTools } from 'config/firebase';
import { sessionReplaced } from 'utils/session/SessionReplaced';

const watchSession = uid => {
    let stopped = false;

    const unsubscribe = fsTools.onSnapshot(
        fsTools.doc(db, 'user_sessions', uid),
        async snapshot => {
            const activeAuthTime = snapshot.data()?.web?.auth_time;

            if (typeof activeAuthTime !== 'number' || !auth.currentUser) {
                return;
            }

            try {
                const { claims } = await auth.currentUser.getIdTokenResult();

                if (!stopped && activeAuthTime > claims.auth_time) {
                    sessionReplaced();
                }
            } catch (error) {
                console.error('Auth Error: Could not read the sign-in time', { error });
            }
        },
        error => {
            console.error('Auth Error: Web session listener failed', { error });
        }
    );

    return () => {
        stopped = true;
        unsubscribe();
    };
};

export const useSessionReplacedListener = () => {
    useEffect(() => {
        let stopWatching = null;

        const unsubscribeAuth = authTools.onAuthStateChanged(auth, user => {
            stopWatching?.();
            stopWatching = user ? watchSession(user.uid) : null;
        });

        return () => {
            unsubscribeAuth();
            stopWatching?.();
        };
    }, []);
};
